import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToForm } from "@/App";

const StickyMobileBar = () => {
  const [formInView, setFormInView] = useState(false);

  useEffect(() => {
    const el = document.querySelector('[data-testid="hero-section"]');
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => setFormInView(entry.isIntersecting),
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <motion.div
      initial={{ y: "110%" }}
      animate={{ y: formInView ? "110%" : 0 }}
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      data-testid="mobile-sticky-bar"
      className="fixed bottom-0 inset-x-0 z-50 lg:hidden bg-navy-deep border-t border-white/10 px-4 pt-3"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <div className="flex gap-3">
        <a
          href="tel:+61494686355"
          data-testid="sticky-call-button"
          className="flex-1 inline-flex items-center justify-center gap-2 border-2 border-amber text-white font-bold text-sm py-3 rounded-lg hover:bg-white/5 transition-colors duration-200"
        >
          Call 0494 686 355
        </a>
        <button
          onClick={scrollToForm}
          data-testid="sticky-quote-button"
          className="flex-1 inline-flex items-center justify-center bg-amber text-navy-deep font-bold text-sm py-3 rounded-lg hover:-translate-y-0.5 transition-transform duration-200 cta-pulse"
        >
          See My Price
        </button>
      </div>
    </motion.div>
  );
};

export default StickyMobileBar;
